export default "__VITE_ASSET__D1GSUaLA__"